<style lang="scss" scoped>
.slide-1 {
  background-image: url(../../../assets/module2/slide1/background-01.png);
  background-color: #fff;
  background-size: cover;
  background-position: center;
  position: relative;
  height: 100%;
  .title-wrap {
    display: inline-block;
  }
  h1 {
    line-height: 1;
    text-align: center;
    font-size: 105px;
    letter-spacing: 0.01em;
    display: inline-block;
    position: absolute;
    right: 13%;
    transform-origin: 100% 0%;
    transform: rotate(-5deg);
    color: #3c7fc1;
    top: 10%;
  }
  .hey h1 {
    transform: rotate(-10deg);
    font-size: 125px;
    right: 55%;
    top: 7%;
  }
  .page-right {
    padding-top: 20%;
    margin-left: auto;
  }
  .content {
    margin-bottom: 2rem;
    color: #000;
  }
  .content3 {
    font-size: 3rem;
    color: #edad18;
    font-family: "Kookycat-FASTcaps";
    font-weight: 100;
  }
}
</style>

<template>
  <div class="slide-1">
    <div class="pages">
      <div class="title-wrap hey">
        <h1 v-html="$t('module2.slide1.heading1')"></h1>
      </div>
      <div class="title-wrap">
        <h1 v-html="$t('module2.slide1.heading2')"></h1>
      </div>
      <div class="page page-right">
        <div v-html="$t('module2.slide1.content1')" class="content"></div>
        <div v-html="$t('module2.slide1.content2')" class="content"></div>
        <div
          v-html="$t('module2.slide1.content3')"
          class="content content3"
        ></div>
      </div>
      <img src="@/assets/module2/slide1/frank-01.png" alt="" class="chars" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
